<main>
    <div class="card" id="card-config">
        <div class="head">
            <h1>Pesquisas</h1>
            <div class="linha">
                <span>lista as pesquisas criadas</span>
                <button class="btn-nav" routerLink="../pesquisa/cadastro">
                    <mat-icon class="material-icons-sharp">
                        checklist
                    </mat-icon> Nova pesquisa
                </button>
            </div>
        </div>
        <div class="table-responsive">
            <table class="table">
                <thead>
                    <tr>
                        <th scope="col">Id</th>
                        <th scope="col">Descrição</th>
                        <th scope="col">Produto</th>
                        <th>Qnt de usuarios que respondeu</th>
                        <th>Porcentagem de satisfação</th>
                        <th>Porcentagem de rejeição</th>
                        <!-- <th scope="col"></th> -->
                        <th scope="col"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr [class.red]="pesquisa.ts_deletado_em != null" *ngFor="let pesquisa of pesquisas">
                        <td scope="row">{{pesquisa.sr_id}}</td>
                        <td>{{pesquisa.vc_descricao}}</td>
                        <td>{{pesquisa.produtos.vc_nome}}</td>
                        <td>{{pesquisa.qntUsuarios}}</td>
                        <td>{{pesquisa.porcentagemAprovacao}}%</td>
                        <td>{{pesquisa.porcentagemInsatisfacao}}%</td>
                        <!-- <td>
                            <button 
                                class="btn-nav" >
                                <mat-icon class="material-icons-sharp">
                                    edit
                                </mat-icon>Editar
                            </button>
                        </td> -->
                        <td>
                            <button *ngIf="pesquisa.ts_deletado_em == null" class="btn-nav" (click)="desativarPesquisa(pesquisa.sr_id)">
                                <mat-icon class="material-icons-sharp del">
                                    delete_forever
                                </mat-icon>Desativar
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</main>